import gql from 'graphql-tag'

export const GET_PLATFORM_NOTIFICATIONS = gql`
  query PlatformNotifications {
    platformNotifications {
      type
      entities_amount
    }
  }
`
